// extracted by mini-css-extract-plugin
module.exports = {"card":"carddetail_card__3B3lX","card_content":"carddetail_card_content__8dhCq","price":"carddetail_price__33u2Z","note":"carddetail_note__1ulr8"};